import { Injectable } from '@angular/core';
import { CreateBlockOptions, PrintBlockItem } from 'src/app/shared';

@Injectable({
  providedIn: 'any',
})
export class PrintBlockService {
  public createBlock(options: CreateBlockOptions): PrintBlockItem {
    const typeId = options.type.id as number;
    const data = options.data;

    const block = this.generateBlocksByDataType(data, typeId);

    block.stock = options.type;

    return block;
  }

  // Private methods --------------------------------------->
  private calculatePrintBlockPageNumber(block: PrintBlockItem): number {
    const difference = block.end - block.start;

    if (difference < 0) {
      throw new Error(
        `[calculatePrintBlockPageNumber][diff:${difference}]: Difference should not be negative.`
      );
    }

    if (difference === 0 && block.end === block.start) {
      return 1;
    } else return difference;
  }

  private generateBlocksByDataType(data: string | number, typeId: number) {
    if (typeof data === 'string') {
      return this.createBlockWithRangeString(data, typeId);
    } else if (typeof data === 'number') {
      return this.createBlockByNumber(data, typeId);
    } else throw new Error('[createBlock]: Unknown type entered.');
  }

  private createBlockWithRangeString(
    range: string,
    typeId: number
  ): PrintBlockItem {
    try {
      const splittedRange = this.rangeStringIsValid(range);
      const start = +splittedRange[0];
      const end = +splittedRange[1];

      return {
        id: 0,
        // actualData: range,
        // isLocal: true,
        start,
        end,
        typeId,
      };
    } catch (err: any) {
      throw new Error(err);
    }
  }

  private createBlockByNumber(num: number, typeId: number): PrintBlockItem {
    let start, end;

    start = num;
    end = num;

    return {
      id: 0,
      // actualData: num,
      // isLocal: true,
      start,
      end,
      typeId,
    };
  }

  private rangeStringIsValid(range: string) {
    const splittedRange = range.split('-');

    if (splittedRange.length !== 2) {
      throw new Error(
        `[rangeStringIsValid][${range}]: Splitted range not valid`
      );
    }

    const start = splittedRange[0];
    const end = splittedRange[1];

    if (start > end)
      throw new Error(
        '[rangeStringIsValid]: Start is bigger than end of range'
      );

    return splittedRange;
  }
}
